__turbopack_context__.v({
  "blok-big-title": "DownloadRecipe-module__tPQ-mW__blok-big-title",
  "blok-subtitle": "DownloadRecipe-module__tPQ-mW__blok-subtitle",
  "blok-title": "DownloadRecipe-module__tPQ-mW__blok-title",
  "buttons": "DownloadRecipe-module__tPQ-mW__buttons",
  "buyerSelect": "DownloadRecipe-module__tPQ-mW__buyerSelect",
  "dialogContent": "DownloadRecipe-module__tPQ-mW__dialogContent",
  "dialogTitle": "DownloadRecipe-module__tPQ-mW__dialogTitle",
  "disabled": "DownloadRecipe-module__tPQ-mW__disabled",
  "errorMessage": "DownloadRecipe-module__tPQ-mW__errorMessage",
});
